"use client";

import { Scale } from "lucide-react";
import { useTranslations } from "next-intl";
import { useComparingProductsStore } from "@/features/products/ui/store";
import { Link } from "@/i18n/navigation";
import { Button } from "@/ui";

export const CompareFloatingBar = () => {
  const generalT = useTranslations("general");
  const { products } = useComparingProductsStore();
  const count = products.length;

  if (count === 0) return null;

  return (
    <div className="fixed right-4 top-1/2 z-50 -translate-y-1/2 md:right-6">
      <Button
        size="icon-lg"
        className="relative rounded-full shadow-lg"
        asChild
        aria-label={`${generalT("go_to_compare")} (${count} ${generalT("items_selected")})`}
      >
        <Link href="/products/compare">
          <Scale />
          <span className="sr-only">{generalT("go_to_compare")}</span>
          <span className="absolute -right-1 -top-1 inline-flex min-h-5 min-w-5 items-center justify-center rounded-full bg-destructive px-1 text-xs font-semibold text-white">
            {count}
          </span>
        </Link>
      </Button>
    </div>
  );
};
